import React from 'react';
import './NavMenu.css';

export const NavMenu = ({ active, setActive }) => {
  const NavMenuButton = ({ label, icon, identifier }) => {
    return (
      <button
        className={`schedules-nav-menu-button ${active === identifier ? 'active' : ''}`}
        onClick={() => setActive(identifier)}
      >
        <i className={`fa ${icon}`}></i>
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="schedules-nav-menu-bar">
      <div className="schedules-nav-menu-group" role="group" aria-label="View Toggle Navigation">
        <NavMenuButton label="All Schedules" icon="fa-calendar" identifier="All Schedules" />
        <NavMenuButton label="Weekly Schedules" icon="fa-calendar-minus-o" identifier="Weekly Schedules" />
        <NavMenuButton label="Shift Management" icon="fa-clock-o" identifier="Shift Management" />
      </div>
    </div>
  );
};
